export default __webpack_public_path__ + "static/btclassic-windows-screen@3x-91d33c994e579e6e4a7c47ba549d57f7.jpg";